// 測定尺度の自動推論

import { DataType, DataValue } from '../../types/core.types';
import { Scale, MeasurementScale, HomogeneousArray } from '../../types/scale.types';

/**
 * データ型と値の分布から測定尺度を推論
 */
export function inferScale(
  dataType: DataType,
  values: DataValue[]
): Scale {

  // boolean型は名義尺度
  if (dataType === 'boolean') {
    return {
      scale: 'nominal',
      validCategories: ['true', 'false'],
      inferredAutomatically: true,
      inferenceReason: 'Boolean values are nominal'
    };
  }

  // 文字列型の処理
  if (dataType === 'string') {
    const nonNullValues = values.filter(v => v !== null);
    const uniqueValues = [...new Set(nonNullValues.map(String))];

    // カテゴリ数が少ない場合は名義尺度
    if (uniqueValues.length <= 20) {
      return {
        scale: 'nominal',
        validCategories: uniqueValues.sort(), // string[]型になる
        inferredAutomatically: true,
        inferenceReason: `Categorical data with ${uniqueValues.length} unique values`
      };
    }

    // カテゴリ数が多い場合も名義尺度（カテゴリリストなし）
    return {
      scale: 'nominal',
      inferredAutomatically: true,
      inferenceReason: `Text data with ${uniqueValues.length} unique values`
    };
  }

  // 数値型の処理
  if (dataType === 'int64' || dataType === 'float64') {
    // 数値型は全て間隔尺度
    return {
      scale: 'interval',
      inferredAutomatically: true,
      inferenceReason: 'Numeric data defaults to interval scale'
    };
  }

  // 日付・時刻型
  if (dataType === 'date' || dataType === 'datetime') {
    return {
      scale: 'interval',
      inferredAutomatically: true,
      inferenceReason: 'Date/time values are interval scale'
    };
  }

  // デフォルト
  return {
    scale: 'nominal',
    inferredAutomatically: true,
    inferenceReason: 'Default fallback'
  };
}

/**
 * 既存の尺度情報を更新（ユーザーが手動で変更した場合）
 */
export function updateScale(
  _existingScale: Scale | undefined,
  newScale: MeasurementScale,
  ordinalOrder?: HomogeneousArray,
  validCategories?: HomogeneousArray
): Scale {
  return {
    scale: newScale,
    ordinalOrder: newScale === 'ordinal' ? ordinalOrder : undefined,
    validCategories: (newScale === 'nominal' || newScale === 'ordinal') ? validCategories : undefined,
    inferredAutomatically: false,
    inferenceReason: 'User specified'
  };
}